export const isDevelopment = process.env.REACT_APP_ENV === 'development';
export const isStaging = process.env.REACT_APP_ENV === 'staging';
export const isProduction = process.env.REACT_APP_ENV === 'production';
